import { Base64 } from "js-base64";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PaymentService from "../../Services/PaymentService";
import AppointmentService from "../../Services/AppointmentService";
import { getCartDetails } from "../../Redux/actions/cartActions";
import moment from "moment";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { BsPatchCheck } from "react-icons/bs";
import Layout from "../../Layout";

const PaymentInitiation = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const decodedValues = Base64.decode(params.transactionId);
  const splitValues = decodedValues.split("|");

  useEffect(() => {
    getpaymentStatus();
  }, [params]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getpaymentStatus = async () => {
    const isCartIdThere = splitValues.some((item) => item.startsWith("CT"));
    let payload = {};

    if (isCartIdThere) {
      payload = {
        transactionId: splitValues[0],
        patientId: splitValues[1],
        serviceTransId: splitValues[2],
      };
    } else {
      payload = {
        transactionId: splitValues[0],
        serviceTransId: splitValues[3],
        patientId: splitValues[1],
        userId: splitValues[2],
        account_Id: splitValues[4],
        clinic_Id: splitValues[5],
      };
    }

    const result = await PaymentService.getTransactionStatus(payload);
    setStatus(result?.data);
    dispatch(getCartDetails({ patientId: payload.patientId }));
    if (result && !isCartIdThere) {
      const payload = { appointmentId: splitValues[3] };
      const resultData = await PaymentService.GetAppointmentId(payload);
      const appointmentDetails = resultData?.data?.[0];
      // if (appointmentDetails) {
      //   const appointmentUpdate = {
      //     appointmentId: appointmentDetails.appointmentId,
      //     email: appointmentDetails.email,
      //     meetingLink: appointmentDetails.meetingLink,
      //     mobile: appointmentDetails.mobile,
      //     id: appointmentDetails.id,
      //     patientId: appointmentDetails.patientId,
      //     status: 1,
      //     paymentReceived: "Y",
      //     userId: appointmentDetails.userId,
      //     createdBy: appointmentDetails.userId,
      //     modifiedBy: appointmentDetails.userId,
      //   };
      //   const updateRes = await AppointmentService.AppointmentUpdate(appointmentUpdate);
      // }
    }
  };

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, HH:mm:ss") => {
    if (!utcDate) return "";
    const localDate = moment.utc(utcDate).local();
    return localDate.format(format);
  };

  const handlepayment = async () => {
    // let cartUpdate = {
    //   cartType: 2,
    //   modifiedBy: loggedUser.user.userId,
    //   patientId: splitValues[1],
    // };
    // const updateRes = await PaymentService.CartUpdate(splitValues[2], cartUpdate);
    navigate(APP_ROUTES.HOME);
  };

  return (
    <Layout>
      <div>
        <div className="min-h-[60vh] flex items-center justify-center">
          {status?.code === "PAYMENT_SUCCESS" && (
            <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full border">
              <div className="text-center">
                <div className="bg-[#E6F2EE] w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <div className="bg-brand-primaryColor w-7 h-7 rounded-full flex items-center justify-center">
                    <BsPatchCheck className="text-white" />
                  </div>
                </div>

                <h2 className="text-xl text-gray-600 font-medium mb-2">
                  Payment Successful
                </h2>
                <p className="text-lg font-bold mb-4">₹ {status?.paidAmount}</p>
              </div>

              <div className="border-t pt-3 space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Transaction ID</span>
                  <span className="font-medium">{status?.transactionId}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Payment Time</span>
                  <span className="font-medium">
                    {convertUTCDateLocal(status?.paidDate)}
                  </span>
                </div>
              </div>

              <button
                onClick={handlepayment}
                className="mt-5 w-full p-2 bg-primaryColor text-white rounded-lg text-lg font-medium"
              >
                Done
              </button>
            </div>
          )}

          {status?.code === "PAYMENT_ERROR" && (
            <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full border text-center">
              <h2 className="text-xl text-red-600 font-medium mb-2">
                Payment Failed
              </h2>
              <p className="text-lg font-bold mb-2">₹ {status?.paidAmount}</p>
              <p className="text-gray-500 mb-4">
                {status?.message || "Transaction unsuccessful"}
              </p>

              <button
                onClick={handlepayment}
                className="w-full p-2 bg-red-500 text-white rounded-lg"
              >
                Go to Dashboard
              </button>
            </div>
          )}

          {!status?.code && status && (
            <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full border text-center">
              <h2 className="text-xl text-yellow-600 font-medium mb-2">
                Payment Pending
              </h2>
              <p className="text-lg font-bold mb-2">₹ {status?.paidAmount}</p>
              <p className="text-gray-500 mb-4">
                Please wait while we confirm your payment.
              </p>

              <button
                onClick={handlepayment}
                className="w-full p-2 bg-primaryColor text-white rounded-lg"
              >
                Done
              </button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default PaymentInitiation;
